(ns common.schema.entities.survey-batch.core
  (:require
   [common.schema.entities.survey-batch.permissions :as permissions]
   [common.schema.entities.survey-batch.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/survey-batch
   :schema                       schema/schema
   :name                         {:en "Survey batch"}
   :plural                       {:en "Survey batches"}
   :icon                         :fa-layer-group
   :display-name-template        "{{survey-batch/batch-label}}"
   :display-name/depends-on      [:survey-batch/batch-label]
   :permissions                  {:creatable?   true
                                  :disableable? true}
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
